// Module
var code = "<react-component name=\"MembershipPlanNacs\"></react-component>\n";
// Exports
module.exports = code;